import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';

export default function CurrencySwitcher() {
  const { currency, switchCurrency, availableCurrencies } = useCurrency();

  return (
    <div className="flex items-center gap-2 bg-neutral-900/50 rounded-lg p-1 border border-neutral-800">
      {availableCurrencies.map((curr) => (
        <button
          key={curr}
          onClick={() => switchCurrency(curr)}
          className={`px-3 py-1.5 rounded-md text-sm font-semibold transition ${
            currency === curr
              ? 'bg-gradient-to-r from-[#CBB26A] to-[#A8914D] text-black'
              : 'text-neutral-400 hover:text-white hover:bg-neutral-800'
          }`}
        >
          {curr}
        </button>
      ))}
    </div>
  );
}
